import { render } from "./SettingsExternalPlugin.vue?vue&type=template&id=d7870b90&scoped=true"
import script from "./SettingsExternalPlugin.vue?vue&type=script&lang=js"
export * from "./SettingsExternalPlugin.vue?vue&type=script&lang=js"

import "./SettingsExternalPlugin.vue?vue&type=style&index=0&id=d7870b90&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7870b90"]])

export default __exports__